import { Box } from "@mui/material";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RHFTextField } from "@rentablo/components";
import { SupportTicketFormValues } from "../types";

type Props = {
  control: Control<SupportTicketFormValues>;
};

export const SupportTicketFields = ({ control }: Props) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" gap={6}>
      <Box
        display="grid"
        gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr" }}
        columnGap={6}
        rowGap={6}
      >
        <RHFTextField
          control={control}
          name="bank"
          label={t("customerSupport.bank.label")}
          fullWidth
        />
        <RHFTextField
          control={control}
          name="isin"
          label={t("customerSupport.isin.label")}
          fullWidth
        />
      </Box>

      <RHFTextField
        control={control}
        name="errorCodeOrUrl"
        label={t("customerSupport.errorCodeOrUrl.label")}
        fullWidth
      />

      <RHFTextField
        control={control}
        name="stepsToReproduce"
        label={t("customerSupport.stepsToReproduce.label")}
        required
        multiline
        rows={4}
        fullWidth
        autoFocus
        // A fixed row count pins the autosized height, so a dragged resize
        // is not recalculated away on the next render.
        sx={{ "& textarea": { resize: "vertical" } }}
      />
    </Box>
  );
};
